var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#B8C6CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4291 40C20.4959 40 14.2598 32.4925 14 20H19.4766C19.6565 29.1692 23.6939 33.0531 26.8919 33.8539V20H32.0487V27.9079C35.2067 27.5676 38.5247 23.964 39.644 20H44.8008C44.379 22.0558 43.5382 24.0024 42.3311 25.7179C41.1239 27.4334 39.5763 28.8809 37.7851 29.97C39.7845 30.9651 41.5505 32.3736 42.9666 34.1025C44.3826 35.8314 45.4165 37.8415 46 40H40.3235C39.7997 38.1252 38.7351 36.4469 37.2631 35.1755C35.7911 33.9041 33.9772 33.0961 32.0487 32.8529V40H31.4291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.5cc118493eef606bd4f0e2b84bda094f.svg";
export { ForwardRef as ReactComponent };